import React from 'react'
import Page from '../../components/page'
import PageTitle from '../../components/page-title'

export default () => (
  <Page>
    <PageTitle title={{ id: 'notFoundPage_heading' }} />
  </Page>
)
